@if (multiline()) {
<textarea
  [zagScrollIntoView]="true"
  class="zag-input zag-input--multiline {{ inputClass() }}"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [attr.id]="id() ?? null"
  [attr.name]="name() ?? null"
  [required]="required()"
  [rows]="rows()"
  [value]="value()"
  [attr.aria-describedby]="ariaDescribedby() ?? null"
  [attr.aria-required]="required() ? 'true' : null"
  [class.focused]="focused()"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
></textarea>
} @else { @if (type() === 'file') {
<input
  [zagScrollIntoView]="true"
  class="zag-input {{ inputClass() }}"
  [type]="type()"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [attr.id]="id() ?? null"
  [attr.name]="name() ?? null"
  [attr.autocomplete]="autocomplete() ?? null"
  [attr.accept]="accept() ?? null"
  [attr.pattern]="pattern() ?? null"
  [required]="required()"
  [attr.aria-describedby]="ariaDescribedby() ?? null"
  [attr.aria-required]="required() ? 'true' : null"
  [class.focused]="focused()"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
/>
} @else { @if (type() === 'search') {
<div class="zag-input__search">
  <span zagIcon="search" class="zag-input__search-icon" aria-hidden="true"></span>
  <input
    [zagScrollIntoView]="true"
    class="zag-input zag-input--with-icon {{ inputClass() }}"
    [class.zag-input--with-clear]="value() !== ''"
    type="search"
    [(value)]="value"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [attr.id]="id() ?? null"
    [attr.name]="name() ?? null"
    [attr.autocomplete]="autocomplete() ?? null"
    [attr.accept]="accept() ?? null"
    [attr.pattern]="pattern() ?? null"
    [required]="required()"
    [attr.aria-describedby]="ariaDescribedby() ?? null"
    [attr.aria-required]="required() ? 'true' : null"
    [class.focused]="focused()"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (focus)="onFocus()"
  />
  @if (value() !== '') {
  <button type="button" class="zag-input__clear" [attr.aria-label]="clearAriaLabel()" (click)="onClearSearch()">
    <span zagIcon="close"></span>
  </button>
  }
</div>
} @else {
<input
  [zagScrollIntoView]="true"
  class="zag-input {{ inputClass() }}"
  [type]="type()"
  [(value)]="value"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [attr.id]="id() ?? null"
  [attr.name]="name() ?? null"
  [attr.autocomplete]="autocomplete() ?? null"
  [attr.accept]="accept() ?? null"
  [attr.pattern]="pattern() ?? null"
  [required]="required()"
  [attr.aria-describedby]="ariaDescribedby() ?? null"
  [attr.aria-required]="required() ? 'true' : null"
  [class.focused]="focused()"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
/>
} } }
